import { styled } from '@mui/material/styles';

export default styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  overflow: 'auto',
  padding: theme.spacing(1.5),
  minHeight: '400px',
}));
